import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import { CategoryTypeEnum } from "../../enums";

export const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/category"),
      }),
      providesTags: ["Categories"],
    }),
    getCategory: builder.query<any, string>({
      query: (id) => ({
        url: `/api/category/${id}`,
      }),
    }),
    getCategorySelectList: builder.query<any, CategoryTypeEnum | void>({
      query: (type) => ({
        url: type
          ? `/api/category/select-list/${type}`
          : `/api/category/select-list`,
      }),
      providesTags: ["Categories-Select-List"],
    }),
    addCategory: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/category",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Categories", "Categories-Select-List"],
    }),
    updateCategory: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/category/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Categories", "Categories-Select-List"],
    }),
    deleteCategory: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Categories", "Categories-Select-List"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryQuery,
  useGetCategorySelectListQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;
